import { ParameterTypeEnum } from '../../../models/enums/parameter-type.enum';
import { DictionaryType } from '../../../models/types/dictionary.type';

export class ParameterTypeMapper {
    static types: DictionaryType<ParameterTypeEnum> = {
        ListTransactionsRequest: ParameterTypeEnum.GridData
    };
}
